import { render, staticRenderFns } from "./change-company-dialog.vue?vue&type=template&id=f4f58e04&scoped=true"
import script from "./change-company-dialog.vue?vue&type=script&lang=js"
export * from "./change-company-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f58e04",
  null
  
)

export default component.exports